import React, { Component } from 'react';
import { observer } from 'mobx-react';
import MigrationStore from 'Stores/migrationStore';
import 'Styles/migration.scss';
import SettingsBlock from 'Components/Common/settingsBlock';
import LoadView from "Components/Common/loadView";
import LoadingIndicator from 'Components/Common/LoadingIndicator';
import { Navigate } from 'react-router-dom';
import AppStore from 'Stores/AppStore';

class Migration extends Component {
    componentDidMount() {
        AppStore.OnMainComponentMount('Миграция', 'migration');
    }

    render() {
        if (!this.props.migrationNeeded) {
            return (
                <Navigate to={`${window.SmrLocation}/`} />
            )
        }

        let migrationInProcess = null;
        if (MigrationStore.migration.migrationInProcess) {
            migrationInProcess =
                <div className='loading-indicator-container'>
                    <div className='loading-indicator-title'>
                        Текущий этап: {MigrationStore.migration.currentMigratonName}
                    </div>
                <LoadingIndicator
                    loaded={MigrationStore.migration.totalProgress.current}
                    total={MigrationStore.migration.totalProgress.total}
                    runner={MigrationStore.migration.totalProgress.total == 0} />

                {
                    MigrationStore.migration.currentProgress.total == 0 ? "" :
                        [
                            <div className='loading-indicator-title'>
                                Прогресс этапа: {MigrationStore.migration.currentProgress.current}/{MigrationStore.migration.currentProgress.total}
                            </div>,
                            <LoadingIndicator
                                loaded={MigrationStore.migration.currentProgress.current}
                                total={MigrationStore.migration.currentProgress.total}
                                runner={MigrationStore.migration.currentProgress.total == 0} />
                        ]
                }                  
                </div>
        }

        return (
            <div className='migration-page'>
                <div className='migration-page-main'>
                    <SettingsBlock title='Миграция'>
                        <div className='migration-block'>
                            <div className='setting-name-with-value'>
                                <div>Статус:</div>
                                <div className={"setting-value"}>{MigrationStore.migration.migrationInProcess ? 'Миграция в процессе' : 'Миграция прервана'}</div>
                            </div>
                            {migrationInProcess}
                        </div>
                    </SettingsBlock>
                </div>
                <div className='settings-buttons-container'>
                    <button className={"blue-button" + ((MigrationStore.migration.migrationInProcess || MigrationStore.startMigrationInProcess) ? ' disabled' : '')}
                        onClick={MigrationStore.StartMigration.bind(MigrationStore)}>
                        {MigrationStore.migration.migrationFirstStarted
                            ? 'Продолжить миграцию'
                            : 'Начать миграцию'}
                    </button>
                </div>
                {MigrationStore.migrationLoading ? <LoadView modal={true} /> : ''}
            </div>
        )
    }
}

export default observer(Migration);